import * as Fields from "#root/components/form/fields";
import StandardEditor from "#root/components/standard-editor";
import type { ReactNode } from "react";
import { journalCollection } from "#root/schema/platform/newsrpm-parser";

import PageLayout from "./layout";

export default function ({ journalId }): ReactNode {
  return (
    <PageLayout title="NewsRPM - Journal">
      <section>
        <StandardEditor id={journalId} collection={journalCollection}>
          <Fields.Set name="uri">
            <label>URL</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="headline">
            <label>Headline</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="provider">
            <label>Provider</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="slug">
            <label>Slug String</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="error">
            <label>Error</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="errorCount">
            <label>Error Count</label>
            <Fields.Number/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="sourceId">
            <label>Source ID</label>
            <Fields.String/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="parserData">
            <label>Parser Data</label>
            <Fields.TextArea rows={5}/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="createdAt">
            <label>Created At</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
          <Fields.Set name="updatedAt">
            <label>Updated</label>
            <Fields.Timestamp/>
            <Fields.Validity/>
          </Fields.Set>
        </StandardEditor>
      </section>
    </PageLayout>
  );
}
